var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{class:{
        'container--columns': true,
        'text-center': _vm.section.textAlign && _vm.section.textAlign === 'center',
        'text-right': _vm.section.textAlign && _vm.section.textAlign === 'right',
    },attrs:{"id":_vm.section.columnId && _vm.section.columnId[_vm.$i18n.locale]
            ? _vm.section.columnId[_vm.$i18n.locale].current
            : _vm.section._key,"fluid":_vm.section.fullWidth}},[_c('v-row',{attrs:{"column":"","justify-center":"","align-center":""}},[_c('v-col',{class:{
                'column-image--left': _vm.section.contentRight,
                'column-image--right': !_vm.section.contentRight,
                'pa-0': true,
            },attrs:{"cols":"12","lg":"6"}},[(_vm.section.video && _vm.section.video.videoID)?_c('EmbedYouTube',{attrs:{"video":_vm.section.video.videoID}}):(
                    _vm.section.image &&
                    _vm.section.image.imageId &&
                    _vm.section.image.imageDir &&
                    _vm.section.isBackground
                )?_c('div',{staticClass:"mdAndDown-h30vw",style:(_vm.calcSanityUrl)}):(
                    _vm.section.sanityImageBackground &&
                    _vm.section.sanityImageBackground.selectedImage
                )?_c('EmbedSanityImage',{attrs:{"selectedImage":_vm.section.sanityImageBackground &&
                    _vm.section.sanityImageBackground.selectedImage,"alt":_vm.section.sanityImageBackground &&
                    _vm.section.sanityImageBackground.alt &&
                    _vm.section.sanityImageBackground.alt[_vm.$i18n.locale]
                        ? _vm.section.sanityImageBackground.alt
                        : {
                              en: 'c3controls image',
                              es: 'c3controls image',
                          },"fit":"scale","image-align":"center","height":"400","width":_vm.$vuetify.breakpoint.lgAndUp ||
                    _vm.$vuetify.breakpoint.xsOnly
                        ? '600'
                        : '720',"border-radius":false,"innerClasses":_vm.$vuetify.breakpoint.xsOnly ? 'no-border-radius' : ''}}):_vm._e()],1),_vm._v(" "),_c('v-col',{class:{
                'column-content--right': _vm.section.contentRight,
                'column-content--left': !_vm.section.contentRight,
                'pa-0': true,
            },attrs:{"cols":"12","lg":"6"}},[(_vm.section.blurbage && _vm.section.blurbage[_vm.$i18n.locale])?_c('div',{class:{
                    'vertical-center-parent': true,
                },staticStyle:{"max-width":"80%","margin":"auto"}},[_c('BlockContent',{attrs:{"blocks":_vm.section.blurbage[_vm.$i18n.locale],"serializers":_vm.serializers}})],1):_vm._e()])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }